<!----
    <button class="left1"  mat-raised-button  (click)="AddMachineCard();">
        <span class="mdc-button__label colr" >Add Machine</span>
    </button><br>
--->
    
     <!-----------------Add folder----------------->
    
     <div class="card wd" *ngIf="CreateMachineShown">
        <form>
        <div class="card-body">
        <div class="form-group">
        <label for="exampleInputPassword1">Machine Name</label><span class="error">{{M_Name}}</span>
        <input type="text" class="form-control" placeholder="Machine name" name="name" [(ngModel)]="data.machine_name"  (ngModelChange)="valuechange1($event)">
        </div>
        
        </div>
       
       
        <div class="card-footer">
        <button class="btns"  mat-raised-button (click)="AddMachine();">
            <span class="mdc-button__label colr" >Added</span>
        </button>
        </div>
        </form>
        </div>
<!---------------------------------new ui---------------------------------------------------->


    <section class="content-header ">
    
    <div class="row mb-2 ">
    <div class="col-sm-6">
    <h1>Machines</h1>
    </div>
    
    
    </div>
    </section>
    <!--------------loader-------------------------->
    <div *ngIf=loaderShown class="loader"></div>
    <!----------------------------------------------->
    
    
    <section class="content">
    
    <div class="card" *ngIf=cardShown>
    <div class="card-header">
    <div class="card-tools">
    <button type="button" class="btn btn-tool" data-card-widget="collapse" title="Collapse">
    <i class="fas fa-minus"></i>
    </button>
    <button type="button" class="btn btn-tool" data-card-widget="remove" title="Remove">
    <i class="fas fa-times"></i>
    </button>
    </div>
    </div>
    <div class="card-body p-0">
    <table class="table table-striped projects">
    <thead>
    <tr>
   

    <th style="width: 30%">
    Machine Name
    </th>
    <th style="width: 35%">
    Machine Id
    </th>
 
    <th>
    </th>
   
    </tr>
    </thead>
    <tbody>

    <tr *ngFor="let c of output">
    <td>
    <a>
    {{c.machine_name}}
    </a>
    </td>

    <td>
    <a>
    {{c._id}}
    </a>
    </td>
    
    <td class="project-actions text-right">
    <a class="btn btn-danger btn-sm left" data-toggle="modal" data-target="#modal-sm" (click)="SetMachineId(c._id,c.machine_name);">
    <i class="fas fa-trash">
    </i>
    Delete
    </a>
    </td>
    </tr>
    

    </tbody>
    </table>
    </div>
    
    </div>
    
    </section>
<!---------------------paging------------------------------------->
<ul class="pagination" *ngIf=cardShown>
    <li class="paginate_button page-item previous" id="example2_previous">
    <a  (click)="clicks_previous()" aria-controls="example2" data-dt-idx="0" tabindex="0" class="page-link count">Previous</a></li>
    
    <li class="paginate_button page-item "><a aria-controls="example2" data-dt-idx="1" tabindex="0" class="page-link count">{{ New_count+1}}</a></li>
               
    <li class="paginate_button page-item next" id="example2_next" >
    <a  (click)="clicks_next()"  aria-controls="example2" data-dt-idx="7" tabindex="0" class="page-link">Next</a></li>
    </ul>
      
    
 <!--------------------delete folder notification---------------------------------------->
<div class="modal fade" id="modal-sm" style="display: none;" aria-hidden="true">
    <div class="modal-dialog modal-sm">
    <div class="modal-content">
    
    <div class="modal-body">
    <p>Delete {{deleteMachineName}}?</p>
    </div>
    <div class="modal-footer justify-content-between">
    <button type="button" class="btn btn-default" data-dismiss="modal">No</button>
    <button type="button" class="btn btn-primary" data-dismiss="modal" (click)="DeleteMachine();">Yes</button>
    </div>
    </div>
    
    </div>
    
    </div>







